import React, { ReactNode } from 'react';

export interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen">
      {children}
    </div>
  );
}

export interface LayoutSidebarProps {
  children: ReactNode;
}

export function LayoutSidebar({ children }: LayoutSidebarProps) {
  return (
    <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 z-10 
                    bg-background border-r">
      {children}
    </div>
  );
}

export interface LayoutHeaderProps {
  className?: string;
  children: ReactNode;
}

export function LayoutHeader({ className, children }: LayoutHeaderProps) {
  return (
    <header className={`flex h-16 items-center border-b px-4 md:px-6 md:ml-64 ${className || ''}`}>
      {children}
    </header>
  );
}

export interface LayoutContentProps {
  className?: string;
  children: ReactNode;
}

export function LayoutContent({ className, children }: LayoutContentProps) {
  return (
    <div className={`flex-1 md:ml-64 p-4 md:p-6 ${className || ''}`}>
      {children}
    </div>
  );
}